var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "tag-tree" }, [_c('mind-map', { ref: "mind-map", attrs: { "tree": _vm.tagTree, "remove-node": _vm.removeNode, "append-child": _vm.appendChild, "edit-node": _vm.updateAppTag, "max-level": 5, "nameMaxLen": 50, "id": "mind-map-" + _vm.tagType } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };